import { render, staticRenderFns } from "./EdimensajeGrid.vue?vue&type=template&id=c8f23cc2"
import script from "./EdimensajeGrid.vue?vue&type=script&lang=js"
export * from "./EdimensajeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports